var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"password-information"},[_vm._v(" Минимальная длина: 8 символов ")])
}
var staticRenderFns = []

export { render, staticRenderFns }